import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { BlogListItem, FeaturedBlogItem, Sidebar } from 'components/blog';

const Wrapper = styled.div`
  max-width: ${props => props.theme.maxWidth};
  margin: 1rem auto;
  display: grid;
  grid-template-columns: 3fr 1fr;
  grid-column-gap: 1rem;
  @media (max-width: ${props => props.theme.breakpoints.l}) {
    grid-template-columns: auto;
  }
`;

const FeaturedBlog = styled.div`
  display: block;
`;

const BlogListItemContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  @media (max-width: ${props => props.theme.breakpoints.xl}) {
    grid-template-columns: 1fr 1fr;
  }
  @media (max-width: ${props => props.theme.breakpoints.m}) {
    grid-template-columns: 1fr;
  }
`;

class BlogContainer extends Component {
  constructor (props) {
    super(props);

    this.state = {
      allPosts: this.props.posts,
      selectedPosts: this.props.posts,
      featuredPost: this.props.featuredPost,
      categories: this.props.categories,
      showFeaturedPost: true
    };

    this.handleSelect = this.handleSelect.bind(this);
  }

  handleSelect = event => {
    const selectedCategory = event.value;
    if (selectedCategory === 'all-posts') {
      this.setState({
        showFeaturedPost: true,
        selectedPosts: [...this.state.allPosts]
      });
    } else {
      this.setState({
        showFeaturedPost: false,
        selectedPosts: [
          ...this.state.allPosts.filter(post => {
            return post.category.slug === selectedCategory;
          })
        ]
      });
    }
  };

  render () {
    const {
      allPosts,
      selectedPosts,
      featuredPost,
      categories,
      showFeaturedPost
    } = this.state;

    return (
      <Wrapper>
        <div>
          {showFeaturedPost && featuredPost &&
            <FeaturedBlog>
              <FeaturedBlogItem
                key={featuredPost.id}
                cover={featuredPost.coverImage.node && featuredPost.coverImage.node.childImageSharp.fluid}
                path={featuredPost.slug}
                title={featuredPost.title}
                subtitle={featuredPost.subtitle}
                excerpt={featuredPost.excerpt}
                readtime={featuredPost.readtime}
              />
            </FeaturedBlog>
          }
          <BlogListItemContainer>
            {selectedPosts.map(post => (
              <BlogListItem
                key={post.id}
                cover={post.coverImage.node && post.coverImage.node.childImageSharp.fluid}
                path={post.slug}
                title={post.title}
                subtitle={post.subtitle}
                readtime={post.readtime}
                excerpt={post.excerpt}
              />
            ))}
          </BlogListItemContainer>
        </div>
        <Sidebar
          posts={allPosts}
          categories={categories}
          handleSelect={this.handleSelect}
        />
      </Wrapper>
    );
  }
}

export default BlogContainer;

BlogContainer.propTypes = {
  posts: PropTypes.array.isRequired,
  featuredPost: PropTypes.object,
  categories: PropTypes.array
};
